module.exports = __webpack_public_path__ + "31a2930b1ae9c28158496ca3293cf38e.png";